import React from "react"
import { Helmet } from "react-helmet"
import { Card, CardBody, Container } from "reactstrap"
//Import Breadcrumb
import Breadcrumbs from "../../../components/Common/Breadcrumb"
import List from "./List"
function PropertyReview() {
  const BreadcrumbDetails = {
    breadcrumbItem: {
      label: "Review",
      link: "/review-properties/list",
    },
    paths: [
      {
        label: "Properties",
        link: "/review-properties/list",
      },
    ],
  }

  return (
    <React.Fragment>
      <Helmet>
        <title>Review Properties | Discover Equestrian</title>
      </Helmet>
      <div className="page-content">
        <Container fluid>
          {/* Render Breadcrumb */}
          <Breadcrumbs breadcrumbDetails={BreadcrumbDetails} />
          <Card>
            <CardBody>
              <List />
            </CardBody>
          </Card>
        </Container>
      </div>
    </React.Fragment>
  )
}

export default PropertyReview
